import { formatMoney } from '@shopify/theme-currency';
import sendQuery from '../../core/storefrontAPI/send-query';
import updateCartQuantity from '../../sections/slider-cart/updateCartQuantity';

export default class CartDrawerDiscount {
  elements;
  promoCodesList;
  totalCodeDiscount;

  constructor() {
    this.elements = {
      cartDrawerDiscountContainer: document.querySelector('[data-slider-cart-discount-form]'),
      discountErrors: document.querySelector('[data-slider-cart-discount-errors]'),
      discountsList: document.querySelector('[data-slider-cart-discount-list]'),
      cartTotalsContainer: document.querySelector('[data-slider-cart-totals]'),
      submitCodeButton: document.querySelector('[data-slider-cart-discount-code-submit]'),
      codeInput: document.querySelector('[data-slider-cart-discount-code]'),
    };

    this.promoCodesList = [];
    this.totalCodeDiscount = 0;

    if (this.elements.submitCodeButton !== null) {
      this.elements.submitCodeButton.addEventListener('click', this.addCode.bind(this));
    }
  }

  /* Called on 1st init and after adding/removing a promo code using updateCartQuantity() */
  init = () => {
    if (typeof window.cart === 'undefined' || window.cart === null || typeof window.cart.token === 'undefined' || window.cart.token === null || !Array.isArray(window.cart.items) || window.cart.items.length === 0) {
      // Hide the promo code field, we will need it if an item gets added later
      this.elements.cartDrawerDiscountContainer?.classList.add('visually-hidden');
      return;
    }

    this.elements.cartDrawerDiscountContainer?.classList.remove('visually-hidden');
    if (this.elements.codeInput) { this.elements.codeInput.value = ''; }

    const existing_savings = document.querySelector('.slider-cart__savings');
    if (existing_savings) {
      existing_savings.remove();
    }

    this.getPromoCodesFromCart();
    this.addTotalSavings();
    this.addAppliedCodesButtons();
  };

  getPromoCodesFromCart = () => {
    window.cart.items.forEach(item => {
      if (item.discounts.length > 0) {
        item.discounts.forEach(code => {
          this.totalCodeDiscount += code.amount;

          if (!this.promoCodesList.includes(code.title)) {
            this.promoCodesList.push(code.title);
          }
        });
      }
    });
  };

  addTotalSavings = () => {
    if (this.totalCodeDiscount === 0) {
      return;
    }

    const div = document.createElement('div');
    div.classList.add('slider-cart__savings');
    div.innerHTML = `You're saving: <span data-savings class="money">${formatMoney(this.totalCodeDiscount, theme.moneyFormat)}</span>`;
    this.elements.cartTotalsContainer.append(div);
  };

  addAppliedCodesButtons = () => {
    try {
      // Validate the discounts list element
      if (!this.elements.discountsList) {
        console.error('[CartDrawerDiscount] Discounts list element is missing.');
        return;
      }
  
      // Clear the discounts list if no promo codes are present
      if (this.promoCodesList.length === 0) {
        this.elements.discountsList.innerHTML = '';
        return;
      }
  
      // SVG for the discount icon
      const svg = `
        <svg class="icon icon--coupon" aria-hidden="true" aria-label="Discount icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor">
          <path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path>
          <path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path>
        </svg>
      `;
  
      // Generate HTML for promo codes
      let codesHtml = '';
      this.promoCodesList.forEach((code) => {
        codesHtml += `
          <div class="slider-cart-summary__discount-code-item" data-slider-cart-discount-code-item>
            ${svg}
            <span>${code}</span>
            <div class="slider-cart-summary__discount-code-remove" data-slider-cart-discount-code-remove data-code="${code}">×</div>
          </div>
        `;
      });
  
      // Update the discounts list with the generated HTML
      this.elements.discountsList.innerHTML = codesHtml;
  
      // Add event listeners to the remove buttons
      const removeCodeButtons = this.elements.discountsList.querySelectorAll('[data-slider-cart-discount-code-remove]');
      removeCodeButtons.forEach((button) => {
        button.addEventListener('click', this.removeCode.bind(this));
      });
    } catch (error) {
      console.error('[CartDrawerDiscount] Error in addAppliedCodesButtons:', error);
    }
  };

  /* Disable/enable elements; add/remove loading status... */
  setBusyState = (is_busy) => {
    (is_busy) ? this.elements.cartDrawerDiscountContainer.classList.add('loading') : this.elements.cartDrawerDiscountContainer.classList.remove('loading');
  };

  /* Update the cart discount using the Storefront API */
  updateCartDiscounts = async () => {
    const query = `
      mutation {
        cartDiscountCodesUpdate(
          cartId: "gid://shopify/Cart/${window.cart.token}"
          discountCodes: [${this.promoCodesList.map(code => `"${code}"`).join(',')}]
        ) {
          cart {
            id
            discountCodes {
              code
              applicable
            }
            checkoutUrl
          }
          userErrors {
            code
            field
            message
          }
        }
      }
    `;

    // console.log(`[ASTR] query`, query);
    const response = await sendQuery(query);
    // console.log(`[ASTR] response`, response);

    if (!response.ok) {
      // throw new Error(`HTTP error ${response.status}`);
      console.log(`HTTP error ${response.status}`);
      return null;
    }

    const response_json = await response.json();

    if (typeof response_json.errors !== 'undefined') {
      console.log('[Storefront API] Error in response:', response_json.errors);
      return null;
    }

    if (typeof response_json.data === 'undefined') {
      console.log('[Storefront API] No data', response_json);
      return null;
    }

    console.log('Storefront API data', response_json.data);
    return response_json.data;
  };

  applyCodeUpdate = async () => {
    this.elements.discountErrors.innerHTML = '';
    this.elements.discountErrors.classList.remove('active');
    this.elements.codeInput.setAttribute('aria-invalid', false);
    let error_message = '';

    this.setBusyState(true);
    const result = await this.updateCartDiscounts();

    if (result === null) {
      error_message += `An error occured, please try later.`;
    } else {
      result?.cartDiscountCodesUpdate?.cart?.discountCodes.forEach(discount => {
        if (!discount.applicable) {
          error_message += `<strong>${discount.code}</strong> couldn't be used with your existing discounts.<br>`;
          this.promoCodesList = this.promoCodesList.filter(code => code !== discount.code);
        }
      });
    }

    if (error_message !== '') {
      this.elements.discountErrors.innerHTML = error_message;
      this.elements.discountErrors.classList.add('active');
      this.elements.codeInput.setAttribute('aria-invalid', true);
      this.elements.codeInput.focus(); // Focus the input so user can correct it
      return;
    }

    await updateCartQuantity(null);
    // this.init();
    this.setBusyState(false);
  };

  /* Remove a promo code */
  removeCode = async (e) => {
    const item = e.currentTarget;
    const promo_code = item.dataset.code;
    console.log(`[ASTR] Remove promo code`, promo_code);

    if (!promo_code || promo_code.length === 0) {
      return;
    }

    // Remove the promo code from the list of codes
    this.promoCodesList = this.promoCodesList.filter(code => code !== promo_code);

    await this.applyCodeUpdate();
  };

  /* Apply a promo code */
  addCode = async (e) => {
    // const item = e.currentTarget;
    const promo_code = this.elements.codeInput.value;
    console.log(`[ASTR] Apply promo code`, promo_code);

    if (!promo_code || promo_code.length === 0 || this.promoCodesList.includes(promo_code) || promo_code.length > 20) {
      return;
    }

    // Add the promo code to the list of codes
    this.promoCodesList.push(promo_code);

    await this.applyCodeUpdate();
  };
}
